// @ts-nocheck
import { Box, Button, DialogActions, Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import { merge } from "lodash";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

import StagingPathologicalDetailsForm from "./StagingPathologicalDetailsForm";

const StagingCycle = ({
  setShowChemo,
  setChemoArray,
  updatedChemo,
  editing,
  prevSavedObj,
}) => {
  const [currentObjToEdit, setCurrentObjToEdit] = useState(null);
  const [editedObj, setEditedObj] = useState(null);

  const StagingPathologicalDetailsFormRef = useRef(null);
  const [page, setPage] = React.useState(1);
  const [total, setTotal] = React.useState(1);

  const handleChange = (event, value) => {
    setPage(value);
    if (
      editing &&
      updatedChemo &&
      updatedChemo.staging_pathological_details &&
      updatedChemo.staging_pathological_details.length > 0
    ) {
      setCurrentObjToEdit(null);
      resetRefValues();
      setTimeout(() => {
        setCurrentObjToEdit(
          updatedChemo.staging_pathological_details[value - 1]
        );
      }, 100);
    } else if (
      editing &&
      !updatedChemo &&
      prevSavedObj &&
      prevSavedObj.staging_pathological_details &&
      prevSavedObj.staging_pathological_details.length > 0
    ) {
      setCurrentObjToEdit(null);
      setEditedObj(null);
      resetRefValues();
      setTimeout(() => {
        setEditedObj(prevSavedObj.staging_pathological_details[value - 1]);
      }, 100);
    }
  };
  const resetRefValues = () => {
    StagingPathologicalDetailsFormRef.current = null;
  };
  useEffect(() => {
    if (
      editing &&
      updatedChemo &&
      updatedChemo.staging_pathological_details &&
      updatedChemo.staging_pathological_details.length > 0
    ) {
      setPage(updatedChemo.staging_pathological_details.length);
      setTotal(updatedChemo.staging_pathological_details.length);

      setCurrentObjToEdit(null);
      resetRefValues();
      setTimeout(() => {
        setCurrentObjToEdit(
          updatedChemo.staging_pathological_details[
            updatedChemo.staging_pathological_details.length - 1
          ]
        );
      }, 100);
    } else if (
      editing &&
      !updatedChemo &&
      prevSavedObj &&
      prevSavedObj.staging_pathological_details &&
      prevSavedObj.staging_pathological_details.length > 0
    ) {
      setPage(prevSavedObj.staging_pathological_details.length);
      setTotal(prevSavedObj.staging_pathological_details.length);
      setEditedObj(null);
      resetRefValues();
      setTimeout(() => {
        setEditedObj(
          prevSavedObj.staging_pathological_details[
            prevSavedObj.staging_pathological_details.length - 1
          ]
        );
      }, 100);
    }

    return () => {};
  }, [updatedChemo, editing, prevSavedObj]);

  return (
    <>
      {editing &&
        ((updatedChemo &&
          updatedChemo.staging_pathological_details &&
          updatedChemo.staging_pathological_details.length > 0) ||
          (prevSavedObj &&
            prevSavedObj.staging_pathological_details &&
            prevSavedObj.staging_pathological_details.length > 0)) && (
          <Stack spacing={2}>
            <Typography>Cycle: {page}</Typography>
            <Pagination count={total} page={page} onChange={handleChange} />
          </Stack>
        )}

      <StagingPathologicalDetailsForm
        editedObj={editedObj}
        onStateChange={(state) => {
          StagingPathologicalDetailsFormRef.current = state;
        }}
        updatedObj={currentObjToEdit}
      />
      <Box
        sx={{
          position: "sticky",
          left: 0,
          bottom: 0,
          backgroundColor: "background.paper",
          borderTop: "1px solid",
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          zIndex: 1000,
          gap: "10px",
          marginTop: "auto",
          padding: "10px",
        }}
        padding={"0px 20px"}
      >
        {" "}
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={1.5}
          width={"100%"}
        >
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="success"
            onClick={() => {
              let objtoPost1 = merge(StagingPathologicalDetailsFormRef.current);

              let objtoPost = {
                ...objtoPost1.staging_pathological_details[0],
              };

              let prevArr =
                updatedChemo &&
                updatedChemo.staging_pathological_details &&
                updatedChemo.staging_pathological_details.length > 0
                  ? updatedChemo.staging_pathological_details
                  : [];
              if (
                !updatedChemo &&
                prevSavedObj &&
                prevSavedObj.staging_pathological_details &&
                prevSavedObj.staging_pathological_details.length > 0
              ) {
                prevArr = prevSavedObj.staging_pathological_details;
              }
              if (
                editing &&
                ((updatedChemo &&
                  updatedChemo.staging_pathological_details &&
                  updatedChemo.staging_pathological_details.length > 0) ||
                  (!updatedChemo &&
                    prevSavedObj &&
                    prevSavedObj.staging_pathological_details &&
                    prevSavedObj.staging_pathological_details.length > 0))
              ) {
                prevArr[page - 1] = objtoPost;
              } else {
                prevArr.push(objtoPost);
              }
              const obj = {
                staging_pathological_details: prevArr,
              };
              resetRefValues();
              setChemoArray(obj);
              setShowChemo(false);
            }}
          >
            Submit
          </Button>
        </Box>{" "}
      </Box>
    </>
  );
};

export default StagingCycle;
